// extracted by mini-css-extract-plugin
export var image = "screenshots-module--image--aac60";
export var laptop = "screenshots-module--laptop--74aea";
export var mobile = "screenshots-module--mobile--0892b";
export var screenshots = "screenshots-module--screenshots--522bb";
export var tablet = "screenshots-module--tablet--d92d1";